import React from "react";
import Heading from "../heading/EventEHRHeading";

interface EventEHRLinkTextWithIconProps {
  imageSrc?: any;
  MUIIcon?: any;
  linkText: string;
  labelCustomStyle?: any;
  handleClickEvent: () => void;
}

const EventEHRLinkTextWithIcon = ({
  imageSrc,
  MUIIcon,
  linkText,
  labelCustomStyle = {
    fontWeight: 500,
    fontSize: "14px",
    color: "#005596",
    cursor: "pointer",
  },
  handleClickEvent,
}: EventEHRLinkTextWithIconProps) => {
  return (
    <div
      className="flex items-center"
      style={{ gap: "10px" }}
      onClick={() => {
        handleClickEvent();
      }}
    >
      {imageSrc && <div className="cursor-pointer">{imageSrc}</div>}
      {MUIIcon && <div className="cursor-pointer">{MUIIcon}</div>}
      <Heading title={linkText} customStyle={labelCustomStyle} />
    </div>
  );
};

export default EventEHRLinkTextWithIcon;
